import HTMLReactParser from "html-react-parser"
import * as Scroll from "react-scroll"
import * as CG from "../../../Components/Global"
import { useLandingContext } from "../../../Context/index"
import Styled from "./section_primary.module.css"

const PagePrimary = () => {
  return (
    <CG.SectionBackgroundImage
      id='inicio'
      background={useLandingContext().websiteSettings.background}
      className={Styled.content_banner_and_title}
    >
      <div className={Styled.container_name_cargo}>
        <h1>José Maria</h1>
        <small>Terapeuta</small>
      </div>
      <p className={Styled.container_title}>
        {HTMLReactParser(
          useLandingContext().websiteSettings.prominentTitle.value
        )}
      </p>
      <div className={Styled.container_button_main}>
        <Scroll.Link to='curriculo' smooth={true}>
          Currículo
        </Scroll.Link>
        <Scroll.Link to='contato' smooth={true}>
          Contato
        </Scroll.Link>
      </div>
    </CG.SectionBackgroundImage>
  )
}

export default PagePrimary
